import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Clock } from 'lucide-react';
import { Card, CardContent } from '../ui/Card';
import { YikiLatestResult } from './YikiLatestResult';
import { formatYikiCountdown, formatYikiPayout } from '../../utils/yikiUtils';

export function YikiRoomCard({ room }) {
  const [displayTime, setDisplayTime] = useState(room.remainingTime);

  useEffect(() => {
    setDisplayTime(room.remainingTime);
  }, [room.remainingTime]);

  useEffect(() => {
    if (!displayTime || displayTime.isExpired) return undefined;

    const timer = setInterval(() => {
      setDisplayTime((prev) => {
        if (!prev || prev.isExpired) return prev;
        let { days, hours, minutes, seconds } = prev;
        if (seconds > 0) seconds -= 1;
        else if (minutes > 0) {
          minutes -= 1;
          seconds = 59;
        } else if (hours > 0) {
          hours -= 1;
          minutes = 59;
          seconds = 59;
        } else if (days > 0) {
          days -= 1;
          hours = 23;
          minutes = 59;
          seconds = 59;
        } else {
          return { ...prev, isExpired: true };
        }
        return { days, hours, minutes, seconds, isExpired: false };
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [displayTime]);

  return (
    <Link to={`/yiki/${room.id}`} className="group block">
      <Card className="h-full border-2 border-gray-200 transition-all hover:border-brand-red hover:shadow-lg">
        <CardContent className="space-y-4 p-5">
          <div className="flex items-start justify-between gap-2">
            <div>
              <h3 className="text-lg font-bold text-brand-red group-hover:underline">
                {room.name}
              </h3>
              <p className="text-xs text-gray-500">{room.label}</p>
            </div>
            <ArrowRight className="h-5 w-5 shrink-0 text-gray-300 transition-colors group-hover:text-brand-red" />
          </div>

          <div className="flex items-center justify-between rounded-xl bg-red-50 px-3 py-2">
            <span className="flex items-center gap-1 text-xs text-gray-600">
              <Clock className="h-3.5 w-3.5" />
              ออกรางวัลใน
            </span>
            <span className="font-mono text-sm font-bold text-brand-red">
              {formatYikiCountdown(displayTime)}
            </span>
          </div>

          <div className="grid grid-cols-2 gap-2 text-center text-sm">
            <div className="rounded-lg border border-brand-gold/40 bg-brand-gold-light/20 p-2">
              <p className="text-xs text-gray-500">2 ตัวท้าย</p>
              <p className="text-xs font-medium leading-tight text-brand-gold">
                {formatYikiPayout(room.multiplierTwo)}
              </p>
            </div>
            <div className="rounded-lg border border-brand-red/20 bg-red-50/50 p-2">
              <p className="text-xs text-gray-500">3 ตัวตรง</p>
              <p className="text-xs font-medium leading-tight text-brand-red">
                {formatYikiPayout(room.multiplierThree)}
              </p>
            </div>
          </div>

          <YikiLatestResult
            result={room.lastResult}
            roundNumber={room.lastRoundNumber}
            variant="compact"
          />

          <p className="text-center text-xs text-gray-400">
            รอบ #{room.round?.roundNumber} · ขั้นต่ำ $1
          </p>
        </CardContent>
      </Card>
    </Link>
  );
}
